export const MESSAGE_TYPE_FILTERS = Object.freeze({
  ALL: "all",
  GUESTS: "guests",
  CONTACTS: "contacts",
  TEAM: "team",
});

export const MESSAGE_TYPE_OPTIONS = Object.freeze([
  { type: MESSAGE_TYPE_FILTERS.ALL, title: "All" },
  { type: MESSAGE_TYPE_FILTERS.GUESTS, title: "Guests" },
  { type: MESSAGE_TYPE_FILTERS.CONTACTS, title: "Contacts" },
  { type: MESSAGE_TYPE_FILTERS.TEAM, title: "Team" },
]);

export const isLeadCategory = (category) =>
  ["lead", "leads"].includes(
    String(category || "")
      .trim()
      .toLowerCase(),
  );

export const hasGuestReservation = (thread) =>
  !!(
    thread?.guest_reservation_id ||
    thread?.guest_reservation?.guest_reservation_id ||
    thread?.guest_reservations?.length
  );

export const messageThreadRecipientType = (thread) => {
  const effectiveRecipientType = String(
    thread?.effective_recipient_type || "",
  )
    .trim()
    .toLowerCase();
  if (["guest", "lead", "contact", "team"].includes(effectiveRecipientType)) {
    return effectiveRecipientType;
  }

  if (thread?.conversation_type === "team") return "team";

  const contactCategory = String(thread?.contact_category || "")
    .trim()
    .toLowerCase();
  if (contactCategory === "guest") return "guest";
  if (isLeadCategory(contactCategory)) {
    return hasGuestReservation(thread) ? "guest" : "lead";
  }
  if (contactCategory) return "contact";
  return "guest";
};

export const threadMatchesMessageType = (
  thread,
  messageType = MESSAGE_TYPE_FILTERS.ALL,
) => {
  if (messageType === MESSAGE_TYPE_FILTERS.ALL) return true;

  const recipientType = messageThreadRecipientType(thread);
  if (messageType === MESSAGE_TYPE_FILTERS.TEAM) {
    return recipientType === "team";
  }
  if (messageType === MESSAGE_TYPE_FILTERS.CONTACTS) {
    return recipientType === "contact";
  }
  if (messageType === MESSAGE_TYPE_FILTERS.GUESTS) {
    return recipientType === "guest";
  }

  return true;
};

export const filterThreadsByMessageType = (threads, messageType) =>
  (Array.isArray(threads) ? threads : []).filter((thread) =>
    threadMatchesMessageType(thread, messageType),
  );
